import { Injectable } from '@angular/core';
import { BaseApiHandleOptions, BaseApiService } from './base-api.service';
import { SearchCountDto, UniversalSearchResponseDto } from '../../dto';
import { Observable } from 'rxjs';
import { UniversalSearchRequestModelInterface } from '../../../core/models';

@Injectable({
    providedIn: 'root'
})
export class UniversalApiService {
    private readonly url: string = 'service/contactcloud/universal';

    constructor(private readonly baseApiService: BaseApiService) {
    }

    getCompanyIds(requestBody, options?: BaseApiHandleOptions) {
        return this.baseApiService.post(
            `${this.url}/companyIds`,
            requestBody,
            options,
        );
    }

    getMatchIdsV2(requestBody) {
        return this.baseApiService.post(`${this.url}/matchIdsV2`, requestBody);
    }

    getSearch(requestBody: UniversalSearchRequestModelInterface): Observable<UniversalSearchResponseDto> {
        return this.baseApiService.post(`${this.url}/search`, requestBody);
    }

    getCounts(requestBody: UniversalSearchRequestModelInterface): Observable<SearchCountDto> {
        return this.baseApiService.post<SearchCountDto>(`${this.url}/count`, requestBody, { showError: true });
    }
}
